import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';

@Component({
  selector: 'side-panel',
  templateUrl: './side-panel.component.html',
  styleUrls: ['./side-panel.component.scss']
})
export class SidePanelComponent implements OnDestroy {
  @Input() headerInfo?: { title: string };
  @Input() expanded = true;
  @Input() hasCustomHeader = false;
  @Output() closed = new EventEmitter<void>();
  @Output() expandedClicked = new EventEmitter<void>();

  ngOnDestroy(): void {
    this.closed.next();
    this.closed.complete();
  }

  closePanel(): void {
    this.closed.emit();
  }

  expandedButtonClicked(): void {
    this.expandedClicked.emit();
  }
}
